import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';

const Banner = styled.div`
  background: ${({ theme }) => theme.colors.yellow4 || '#FFD600'};
  color: ${({ theme }) => theme.colors.black || '#000'};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-m);
  padding: 0.6rem 1rem;
  font-weight: 700;
  font-size: 0.95rem;

  @media (max-width: 900px) {
    padding: 0.5rem 0.75rem;
    font-size: 0.9rem;
  }

  @media (max-width: 600px) {
    /* keep it on a single line on small screens */
    flex-direction: row;
    align-items: center;
    text-align: left;
    gap: 0.5rem;
    padding: 0.45rem 0.6rem;
    /* border: 1px solid red; */
    white-space: nowrap;
    overflow-x: auto;
    span {
      font-size: 0.8rem !important;
    }
  }
`;

const CTA = styled.button`
  background: ${({ theme }) => theme.colors.black || '#000'};
  color: ${({ theme }) => theme.colors.white || '#fff'};
  border: none;
  padding: 0.4rem 0.8rem;
  border-radius: 999px;
  margin-left: 0.5rem;
  cursor: pointer;
  font-weight: 700;

  @media (max-width: 600px) {
    display: none;
  }
`;

const InlineCTA = styled.button`
  display: none;
  align-items: center;
  gap: 0.35rem;
  background: transparent;
  border: 0;
  color: ${({ theme }) => theme.colors.black || '#000'};
  font-weight: 700;
  cursor: pointer;

  @media (max-width: 600px) {
    display: inline-flex;
  }
`;

const NewBanner = () => {
  const navigate = useNavigate();

  return (
    <Banner role="region" aria-label="What's new banner">
      <span style={{ fontWeight: '600' }}>
        <span style={{ color: 'red', fontWeight: 'bold' }}>NEW:</span> Safety,
        Commercial & Industrial Supplies Now Available
      </span>
      {/* Media screen hide this  */}
      <CTA
        type="button"
        onClick={() => {
          navigate('/explore-products');
        }}
        aria-label="Shop new safety products"
      >
        Shop Now
      </CTA>
      <InlineCTA
        type="button"
        onClick={() => {
          navigate('/explore-products');
        }}
        aria-label="Shop new safety products"
      >
        Shop now <FaArrowRight aria-hidden="true" style={{ marginLeft: 6 }} />
      </InlineCTA>
    </Banner>
  );
};

export default NewBanner;
